import React, { useState } from "react";
import Link from "next/link";
import { ThreeDots } from "react-loader-spinner";
import { createStripeSubscriptionUSWithTrial } from "../../../utils/stripe";
import {
  ONE_DOLLAR_TRIAL_PRICE_ID,
  FREELANCER_PLAN_MONTHLY_PRICE_ID,
  FREELANCER_PLAN_ANNUALLY_PRICE_ID,
  TEAM_PLAN_MONTHLY_PRICE_ID,
  TEAM_PLAN_ANNUALLY_PRICE_ID,
  GROWING_BUSINESS_PLAN_MONTHLY_PRICE_ID,
  GROWING_BUSINESS_PLAN_ANNUALLY_PRICE_ID,
} from "../../../constants/constants";
import styles from "../../../components/v2/Buttons/buttons.module.css";

const Button1 = ({
  btnText,
  btnLink,
  setSignaturePopup,
  bgColor = "bg-black",
  textColor = "text-white",
  border = "border-2 border-black",
  priceId = FREELANCER_PLAN_MONTHLY_PRICE_ID,
  trialPriceId = ONE_DOLLAR_TRIAL_PRICE_ID,
  billing_action = "billing_click_subscribe",
  plan = "FreeLancer Plan",
  planCycle = "monthly",
  amount = "15",
  quantity = "1",
  email = "",
  showLoading = true,
  borderShadow,
  px = "px-8",
  borderRadius = "rounded-lg",
  icon,
  mb = "",
  width = "",
  height = "",
}) => {
  // console.log(priceId, trialPriceId, billing_action, plan, planCycle, amount, quantity, email)
  const [loading, setLoading] = useState(false);
  return (
    <button
      className={`${bgColor} ${textColor} ${border} ${
        borderShadow ? styles.buttonPrimary : "hover:opacity-90"
      } text-base sm:text-lg ${px} py-3 ${height} ${borderRadius} ${mb} ${width} flex justify-center items-center gap-3`}
      onClick={async () => {
        if (btnLink) {
          window.open(btnLink, "_self");
          return;
        }
        if (setSignaturePopup) {
          setSignaturePopup((prev) => ({ ...prev, open: true }));
          return;
        } else {
          setLoading(true);
          await createStripeSubscriptionUSWithTrial(
            priceId,
            trialPriceId,
            billing_action,
            plan,
            planCycle,
            amount,
            quantity,
            email
          );
          setLoading(false);
        }
      }}
    >
      {btnText}
      {icon && <span className="text-2xl">{icon}</span>}
      {loading && showLoading && (
        <ThreeDots
          visible={true}
          height="30"
          width="40"
          color="#7E60BF"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      )}
    </button>
    // <Link
    //   href={btnLink}
    //   className={`${bgColor} ${textColor} ${border} text-base sm:text-lg px-8 py-3 rounded-lg hover:opacity-90`}
    // >
    //   {btnText}
    // </Link>
  );
};
const Button2 = ({
  btnText,
  btnLink,
  bgColor = "bg-transparent",
  textColor = "text-black",
  border = "border-2 border-black",
}) => {
  return (
    <Link
      href={btnLink}
      className={`${bgColor} ${textColor} ${border} text-base sm:text-lg px-8 py-3 rounded-lg hover:opacity-90`}
    >
      {btnText}
    </Link>
  );
};

export { Button1, Button2 };
